"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MessageHeader_Response = exports.MessageHeader_ResponseCodeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Reference_1 = require("./RTTI_Reference");
var MessageHeader_ResponseCodeKind;
(function (MessageHeader_ResponseCodeKind) {
    MessageHeader_ResponseCodeKind["_ok"] = "ok";
    MessageHeader_ResponseCodeKind["_transientError"] = "transient-error";
    MessageHeader_ResponseCodeKind["_fatalError"] = "fatal-error";
})(MessageHeader_ResponseCodeKind = exports.MessageHeader_ResponseCodeKind || (exports.MessageHeader_ResponseCodeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_MessageHeader_Response = t.recursion('IMessageHeader_Response', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        identifier: RTTI_id_1.RTTI_id,
        _identifier: RTTI_Element_1.RTTI_Element,
        code: (0, EnumType_1.createEnumType)(MessageHeader_ResponseCodeKind, 'MessageHeader_ResponseCodeKind'),
        _code: RTTI_Element_1.RTTI_Element,
        details: RTTI_Reference_1.RTTI_Reference
    });
});
//# sourceMappingURL=RTTI_MessageHeader_Response.js.map